import { graphql } from '@graphql/__generated'

export const TRIGGER_EVENT_EMAIL = graphql(`
  mutation triggerEventEmail($eventId: String!, $template: String!) {
    triggerEventEmail(eventId: $eventId, emailTemplate: $template)
  }
`)
